var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.783936C9.98912 0.783936 11.8968 1.57411 13.3033 2.98063C14.7098 4.38716 15.5 6.29481 15.5 8.28394C15.5 9.26885 15.306 10.2441 14.9291 11.1541C14.5522 12.064 13.9997 12.8908 13.3033 13.5872C11.8968 14.9938 9.98912 15.7839 8 15.7839C6.01088 15.7839 4.10322 14.9938 2.6967 13.5872C1.29018 12.1807 0.5 10.2731 0.5 8.28394C0.5 7.29902 0.693993 6.32375 1.0709 5.41381C1.44781 4.50387 2.00026 3.67707 2.6967 2.98063C3.39314 2.28419 4.21993 1.73175 5.12987 1.35484C6.03982 0.977928 7.01509 0.783936 8 0.783936ZM8.75 12.7839V6.78394L11.375 9.40894L12.44 8.34394L8 3.90394L3.56 8.34394L4.625 9.40894L7.25 6.78394L7.25 12.7839H8.75Z",
    fill: "#F7A500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.043142e33383106f098e9b5347b17d6a.svg";
export { ForwardRef as ReactComponent };